import {
    b64Uri,
    bodyRequest,
    getElement,
    getJson,
    requestOptions,
    resetForm,
} from "../../../../../helpers";

export class DirectoryModal extends HTMLDivElement {
    connectedCallback() {
        // console.log(this);
        const Form = getElement("[data-form=form]", this);

        Form.elements.save.addEventListener("click", async () => {
            if (Form.reportValidity()) {
                bodyRequest.set("name", Form.elements.name.value);
                const R = await fetch(Form.action, requestOptions);
                const T = await R.json();
                console.log(T);

                if (T.success) {
                    Form.elements.cancel.click();
                    let allElements =
                        document.querySelectorAll("[data-breadcrumbs]");
                    let lastElement = allElements[allElements.length - 1];
                    lastElement.click();
                } else {
                    //
                }
            }
        });
    }

    static create(modal, title, url) {
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
    }

    static edit(modal, title, url, data) {
        data = getJson(b64Uri(data, "decode"));
        const Form = getElement("[data-form=form]", getElement(modal));
        resetForm(Form, title, url);
        Form.elements.name.value = data.name;
    }
}

window.customElements.define("directory-modal", DirectoryModal, {
    extends: "div",
});
